import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight, ArrowUpRight } from "lucide-react";

// STILL — Move differently. Live differently.
const CHARCOAL = "#242323", BONE = "#F5F0E8", MERLOT = "#651F33", SAGE = "#87958A";
const MONT = "'Montserrat', system-ui, sans-serif";

const HERO_IMG = "https://images.unsplash.com/photo-1554284126-aa88f22d8b74?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwxfHxkaXZlcnNlJTIwcGVvcGxlJTIwbW92ZW1lbnQlMjBzdHJlbmd0aCUyMHRyYWluaW5nfGVufDB8fHx8MTc4ODEzNjE4OHww&ixlib=rb-4.1.0&q=85";
const MOVE_IMG = "https://images.unsplash.com/photo-1518310383802-640c2de311b2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwzfHxkaXZlcnNlJTIwcGVvcGxlJTIwbW92ZW1lbnQlMjBzdHJlbmd0aCUyMHRyYWluaW5nfGVufDB8fHx8MTc4ODEzNjE4OHww&ixlib=rb-4.1.0&q=85";
const COMMUNITY_IMG = "https://images.unsplash.com/photo-1763890763432-17c9a529da20?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwyfHxwYXJlbnQlMjBjaGlsZCUyMHdhbGtpbmclMjBvdXRkb29ycyUyMHRvZ2V0aGVyfGVufDB8fHx8MTc4ODEzNjE4OHww&ixlib=rb-4.1.0&q=85";
const PROD_TAN = "https://images.unsplash.com/photo-1691132615844-b013a05b51e7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwyfHxtaW5pbWFsJTIwbmV1dHJhbCUyMGFwcGFyZWwlMjBob29kaWUlMjBmbGF0bGF5fGVufDB8fHx8MTc4ODEzNjE4OHww&ixlib=rb-4.1.0&q=85";
const PROD_WHITE = "https://images.unsplash.com/photo-1620799140188-3b2a02fd9a77?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwzfHxtaW5pbWFsJTIwbmV1dHJhbCUyMGFwcGFyZWwlMjBob29kaWUlMjBmbGF0bGF5fGVufDB8fHx8MTc4ODEzNjE4OHww&ixlib=rb-4.1.0&q=85";
const PROD_DARK = "https://images.unsplash.com/photo-1581655353466-d5ad6765dd37?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwxfHxtaW5pbWFsJTIwbmV1dHJhbCUyMGFwcGFyZWwlMjBob29kaWUlMjBmbGF0bGF5fGVufDB8fHx8MTc4ODEzNjE4OHww&ixlib=rb-4.1.0&q=85";

const JOURNEY = ["START", "MOVE", "ADAPT", "RECOVER", "RETURN", "GROW"];
const PRODUCTS = [
  { img: PROD_DARK, name: "Movement Hoodie", cat: "Apparel" },
  { img: PROD_TAN, name: "Everyday Crewneck", cat: "Apparel" },
  { img: PROD_WHITE, name: "STILL Tee", cat: "Apparel" },
];

const Word = ({ children, style, className = "" }) => (
  <span style={{ fontFamily: MONT, letterSpacing: "0.14em", ...style }} className={className}>{children}</span>
);

export default function Landing() {
  const navigate = useNavigate();
  const go = () => navigate("/login");

  return (
    <div style={{ background: BONE, color: CHARCOAL, fontFamily: MONT }} className="min-h-screen">
      {/* Nav */}
      <header className="sticky top-0 z-40 backdrop-blur-md" style={{ background: BONE + "E6", borderBottom: `1px solid ${CHARCOAL}1a` }}>
        <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
          <Word className="text-2xl font-black" style={{ letterSpacing: "0.28em" }}>STILL</Word>
          <nav className="hidden md:flex items-center gap-9 text-[13px] font-semibold" style={{ letterSpacing: "0.08em" }}>
            {[["Philosophy", "#philosophy"], ["Movement", "#movement"], ["Journey", "#journey"], ["Community", "#community"]].map(([l, h]) => (
              <a key={l} href={h} className="uppercase transition-opacity hover:opacity-60">{l}</a>
            ))}
          </nav>
          <div className="flex items-center gap-2">
            <button data-testid="nav-login-button" onClick={go} className="text-[13px] font-bold uppercase px-4 py-2 transition-opacity hover:opacity-60" style={{ letterSpacing: "0.08em" }}>Log in</button>
            <button data-testid="nav-getstarted-button" onClick={go} className="text-[13px] font-bold uppercase px-5 py-2.5 rounded-full transition-transform hover:-translate-y-0.5" style={{ background: MERLOT, color: BONE, letterSpacing: "0.08em" }}>Start Moving</button>
          </div>
        </div>
      </header>

      {/* Hero */}
      <section className="relative overflow-hidden" style={{ background: CHARCOAL }}>
        <img src={HERO_IMG} alt="People moving with intention" className="absolute inset-0 w-full h-full object-cover opacity-30" />
        <div className="absolute inset-0" style={{ background: `linear-gradient(180deg, ${CHARCOAL}cc, ${CHARCOAL}f2)` }} />
        <div className="relative max-w-6xl mx-auto px-6 py-28 md:py-36">
          <p className="uppercase text-[12px] font-semibold mb-6" style={{ color: SAGE, letterSpacing: "0.32em" }}>Still here · Still becoming · Still moving</p>
          <h1 className="font-black leading-[0.92] text-6xl sm:text-7xl lg:text-8xl" style={{ color: BONE, letterSpacing: "0.02em" }}>
            MOVE<br />DIFFERENTLY.<br /><span style={{ color: SAGE }}>LIVE DIFFERENTLY.</span>
          </h1>
          <p className="mt-8 text-lg md:text-xl max-w-xl font-medium" style={{ color: BONE + "cc" }}>
            Fitness isn't a destination. It's a decision you keep making.
          </p>
          <div className="mt-10 flex flex-wrap gap-3">
            <button data-testid="hero-getstarted-button" onClick={go} className="flex items-center gap-2 text-sm font-bold uppercase px-8 py-4 rounded-full transition-transform hover:-translate-y-0.5" style={{ background: MERLOT, color: BONE, letterSpacing: "0.1em" }}>
              Start Moving <ArrowRight size={17} />
            </button>
            <button data-testid="hero-login-button" onClick={() => { document.getElementById("philosophy")?.scrollIntoView({ behavior: "smooth" }); }} className="text-sm font-bold uppercase px-8 py-4 rounded-full border transition-colors" style={{ color: BONE, borderColor: BONE + "55", letterSpacing: "0.1em" }}>
              Explore STILL
            </button>
          </div>
        </div>
      </section>

      {/* Section 1 — Philosophy */}
      <section id="philosophy" className="max-w-6xl mx-auto px-6 py-24 md:py-32">
        <h2 className="font-black leading-[1.05] text-4xl sm:text-5xl lg:text-6xl">
          STILL HERE.<br /><span style={{ color: MERLOT }}>STILL BECOMING.</span><br />STILL MOVING.
        </h2>
        <div className="mt-10 grid md:grid-cols-2 gap-8 max-w-4xl">
          <p className="text-lg leading-relaxed" style={{ color: CHARCOAL + "cc" }}>
            Life doesn't move in a straight line. There are seasons of discipline, growth, grief, rest — and seasons where simply beginning again is an act of strength. STILL exists for all of them.
          </p>
          <p className="text-lg leading-relaxed" style={{ color: CHARCOAL + "cc" }}>
            This isn't a brand that says you need to become someone else. It says: become more of who you are. You don't have to move like everyone else to move forward.
          </p>
        </div>
      </section>

      {/* Section 2 — Movement without perfection */}
      <section id="movement" className="relative">
        <div className="max-w-6xl mx-auto px-6 pb-8 grid md:grid-cols-2 gap-8 items-center">
          <div className="relative rounded-[2rem] overflow-hidden min-h-[360px]">
            <img src={MOVE_IMG} alt="Diverse people moving together" className="absolute inset-0 w-full h-full object-cover" />
          </div>
          <div>
            <p className="uppercase text-[12px] font-semibold mb-4" style={{ color: SAGE, letterSpacing: "0.3em" }}>Movement without perfection</p>
            <h2 className="font-black text-4xl sm:text-5xl leading-[1.02]">YOUR MOVEMENT.<br /><span style={{ color: MERLOT }}>YOUR WAY.</span></h2>
            <p className="mt-6 text-lg leading-relaxed" style={{ color: CHARCOAL + "cc" }}>
              Strength training or a first walk after months away. Recovery, mobility, or chasing your kids around the yard. Movement is personal — your pace is yours, your starting point is yours.
            </p>
            <p className="mt-4 font-bold" style={{ color: MERLOT }}>You belong here, exactly where you are.</p>
          </div>
        </div>
      </section>

      {/* Section 3 — The STILL Journey */}
      <section id="journey" className="mt-16" style={{ background: CHARCOAL }}>
        <div className="max-w-6xl mx-auto px-6 py-24">
          <p className="uppercase text-[12px] font-semibold mb-3" style={{ color: SAGE, letterSpacing: "0.3em" }}>The STILL journey</p>
          <h2 className="font-black text-4xl sm:text-5xl mb-12" style={{ color: BONE }}>PROGRESS IS A LOOP,<br />NOT A LINE.</h2>
          <div className="flex flex-wrap items-center gap-y-6">
            {JOURNEY.map((step, i) => (
              <React.Fragment key={step}>
                <div className="flex items-center gap-3">
                  <span className="w-9 h-9 rounded-full flex items-center justify-center text-[12px] font-black" style={{ background: MERLOT, color: BONE }}>{i + 1}</span>
                  <Word className="font-black text-lg sm:text-xl" style={{ color: BONE, letterSpacing: "0.12em" }}>{step}</Word>
                </div>
                {i < JOURNEY.length - 1 && <ArrowRight className="mx-4 hidden sm:block" size={18} style={{ color: SAGE }} />}
              </React.Fragment>
            ))}
          </div>
        </div>
      </section>

      {/* Section 4 — Community */}
      <section id="community" className="max-w-6xl mx-auto px-6 py-24 grid md:grid-cols-2 gap-8 items-center">
        <div>
          <p className="uppercase text-[12px] font-semibold mb-4" style={{ color: SAGE, letterSpacing: "0.3em" }}>Community</p>
          <h2 className="font-black text-5xl sm:text-6xl leading-[0.98]">WE MOVE<br />TOGETHER.</h2>
          <p className="mt-6 text-lg leading-relaxed" style={{ color: CHARCOAL + "cc" }}>
            Families, friends, and generations moving side by side. Because the choices you make for yourself can reach far beyond you — into your family's trajectory and the patterns you break.
          </p>
        </div>
        <div className="relative rounded-[2rem] overflow-hidden min-h-[380px] order-first md:order-last">
          <img src={COMMUNITY_IMG} alt="A family walking together" className="absolute inset-0 w-full h-full object-cover" />
        </div>
      </section>

      {/* Section 5 — Products */}
      <section id="products" className="max-w-6xl mx-auto px-6 pb-24">
        <div className="flex items-end justify-between mb-8">
          <div>
            <p className="uppercase text-[12px] font-semibold mb-2" style={{ color: SAGE, letterSpacing: "0.3em" }}>The STILL collection</p>
            <h2 className="font-black text-4xl sm:text-5xl">WEAR THE REMINDER.</h2>
          </div>
          <span className="text-[12px] font-bold uppercase px-3 py-1.5 rounded-full" style={{ background: SAGE + "33", color: CHARCOAL, letterSpacing: "0.1em" }}>Coming soon</span>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
          {PRODUCTS.map((p) => (
            <div key={p.name} className="group">
              <div className="relative rounded-[1.5rem] overflow-hidden aspect-[4/5]" style={{ background: "#EFE7DA" }}>
                <img src={p.img} alt={p.name} className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
              </div>
              <div className="flex items-center justify-between mt-3">
                <div>
                  <p className="font-bold">{p.name}</p>
                  <p className="text-[12px] uppercase" style={{ color: SAGE, letterSpacing: "0.1em" }}>{p.cat}</p>
                </div>
                <ArrowUpRight size={18} style={{ color: MERLOT }} />
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Section 6 — Brand philosophy */}
      <section style={{ background: MERLOT }}>
        <div className="max-w-6xl mx-auto px-6 py-28 text-center">
          <h2 className="font-black leading-[1.08] text-4xl sm:text-6xl" style={{ color: BONE }}>
            STILL GRIEVING.<br />STILL HEALING.<br />STILL LEARNING.<br /><span style={{ color: SAGE }}>STILL MOVING.</span>
          </h2>
        </div>
      </section>

      {/* Final CTA */}
      <section style={{ background: CHARCOAL }}>
        <div className="max-w-4xl mx-auto px-6 py-28 text-center">
          <h2 className="font-black text-4xl sm:text-5xl leading-[1.05]" style={{ color: BONE }}>
            YOU ARE STILL HERE.<br /><span style={{ color: SAGE }}>WHAT ARE YOU GOING TO DO WITH IT?</span>
          </h2>
          <button data-testid="final-cta-button" onClick={go} className="mt-10 inline-flex items-center gap-2 text-sm font-bold uppercase px-9 py-4 rounded-full transition-transform hover:-translate-y-0.5" style={{ background: MERLOT, color: BONE, letterSpacing: "0.12em" }}>
            Move Forward <ArrowRight size={17} />
          </button>
        </div>
      </section>

      {/* Footer */}
      <footer style={{ background: CHARCOAL, borderTop: `1px solid ${BONE}1a` }}>
        <div className="max-w-6xl mx-auto px-6 py-12 flex flex-col md:flex-row items-center justify-between gap-5">
          <Word className="text-xl font-black" style={{ color: BONE, letterSpacing: "0.28em" }}>STILL</Word>
          <p className="text-[13px]" style={{ color: SAGE }}>Move differently. Live differently. © {new Date().getFullYear()} STILL.</p>
          <div className="flex items-center gap-6 text-[13px] font-semibold uppercase" style={{ color: BONE + "aa", letterSpacing: "0.08em" }}>
            <a href="#philosophy" className="hover:opacity-70">Philosophy</a>
            <a href="#journey" className="hover:opacity-70">Journey</a>
            <button onClick={go} className="hover:opacity-70 uppercase">Log in</button>
          </div>
        </div>
      </footer>
    </div>
  );
}
